import React from 'react';
import { ButtonNew } from '../../ButtonNew';
import { useRouting } from '../../../shared/use-routing';
import { pagePathnames } from '../../../pages/page-routes';
import mainSrc from '../../../assets/images/start/main.webp';
import mainMobileSrc from '../../../assets/images/start/main-mobile.webp';
import questionCardStackSrc from '../../../assets/images/start/question-card-stack.png';
import styles from './Hero.css';

function Hero() {
    const { buildPath } = useRouting();

    return (
        <section className={styles.mainSection}>
            <div className={styles.mainContent}>
                <h1 className={styles.title}>Your life is a story worth keeping</h1>
                <p className={styles.subtitle}>
                    Boundly uses adaptive AI to uncover the moments, choices, and people that shaped you — then turns your spoken or typed memories into a private Digital Family Legacy Book. Create it for yourself or help someone you love preserve theirs.
                </p>
                <ButtonNew
                    type='pill'
                    label='Sign in'
                    link={{ to: buildPath(pagePathnames.signIn) }}
                />
            </div>
            <div className={styles.mainImageWrapper}>
                <picture>
                    <source
                        srcSet={mainMobileSrc}
                        media='(max-width: 518px)'
                    />
                    <img
                        src={mainSrc}
                        alt='Two women looking at a laptop together on a couch'
                        className={styles.mainImage}
                    />
                </picture>
                <img
                    src={questionCardStackSrc}
                    alt='question card stack'
                    className={styles.questionCardStack}
                />
            </div>
        </section>
    );
}

export {
    Hero
};
